import Alert from "@mui/material/Alert";

export function SnackbarError(props) {
    return (
        <Alert elevation={3} variant="filled" severity="error" {...props.alertProps}>
            {props.message}
        </Alert>
    );
}
